import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["access", "expiration"]

  initialize() {
    this.readOnlyOptions = Array.from(this.element.querySelectorAll("option[data-read-access-only]"))
    this.updateExpirationOptions()
  }

  updateExpirationOptions() {
    if (this.#writeAccessSelected) {
      this.#removeReadOnlyOptions()
    } else {
      this.#addReadOnlyOptions()
    }
  }

  #removeReadOnlyOptions() {
    for (const option of this.readOnlyOptions) {
      if (option.isConnected) option.remove()
    }
  }

  #addReadOnlyOptions() {
    for (const option of this.readOnlyOptions) {
      if (!option.isConnected) this.expirationTarget.prepend(option)
    }
  }

  get #writeAccessSelected() {
    return this.accessTarget.value.includes("write")
  }
}
